// src/components/Banner.tsx

import React, { useEffect, useState } from 'react';
import '../css/Section.css';

interface SectionProps {
    title?: string;
    subtitle?: string;
    imagepath?: string ;
  }
const Section: React.FC<SectionProps> = ({title,subtitle ,imagepath}) => {
       return (
        <section className="who-we-are">
        <div className="container">
          <div className="section-title">
            <h5 className="sub-title">{subtitle}</h5>
            {title != null && <h2 className="title">{title}</h2>}
          </div>
        </div>
      </section>
      );
};

export default Section;
